// src/pages/admin/PageAuditLog.jsx
import React, { useState, useEffect, useRef } from "react";
import * as api from "../../apiService";

export function PageAuditLog() {
  const [logs,       setLogs]       = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState(null);
  const [expanded,   setExpanded]   = useState({});
  const [entityType, setEntityType] = useState("");
  const [actorEmail, setActorEmail] = useState("");
  const [from,       setFrom]       = useState("");
  const [to,         setTo]         = useState("");
  const cancelRef = useRef(false);

  async function load() {
    cancelRef.current = false;
    setLoading(true); setError(null);
    try {
      const result = await api.fetchAuditLog({ entityType, actorEmail, from, to });
      if (!cancelRef.current) setLogs(result);
    } catch (e) {
      if (!cancelRef.current) setError(e.message);
    } finally {
      if (!cancelRef.current) setLoading(false);
    }
  }

  useEffect(() => {
    load();
    return () => { cancelRef.current = true; };
  }, []); // eslint-disable-line

  return (
    <>
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-title">Audit Log</div>
          <div className="page-subtitle">Append-only record of all data changes</div>
        </div>
      </div>
      <div className="action-bar" style={{ flexWrap:"wrap" }}>
        <input className="form-input" style={{ width:180 }} placeholder="Entity type…" value={entityType} onChange={e => setEntityType(e.target.value)} />
        <input className="form-input" style={{ width:220 }} placeholder="Actor email…" value={actorEmail} onChange={e => setActorEmail(e.target.value)} />
        <input className="form-input" style={{ width:140 }} type="date" value={from} onChange={e => setFrom(e.target.value)} />
        <input className="form-input" style={{ width:140 }} type="date" value={to}   onChange={e => setTo(e.target.value)} />
        <button className="btn-primary" onClick={load}>Search</button>
      </div>
      {loading && <div style={{ color:"#aaa", fontSize:12 }}>Loading…</div>}
      {error   && <div className="alert-warn">Error: {error}</div>}
      <div className="card">
        <div className="table-wrap">
        <table className="data-table">
          <thead><tr>
            <th>Time</th><th>Actor</th>
            <th>Action</th><th>Entity</th><th>ID</th><th></th>
          </tr></thead>
          <tbody>
            {logs.map((l, i) => (
              <React.Fragment key={l.id ?? i}>
                <tr style={{ background: i%2===0?"#fff":"#fafafa" }}>
                  <td style={{ fontSize:11, color:"#999", whiteSpace:"nowrap" }}>{(l.occurred_at||"").toString().replace("T"," ").slice(0,19)}</td>
                  <td style={{ fontSize:11 }}>{l.actor_email||"—"}</td>
                  <td><span className="badge badge-blue">{l.action}</span></td>
                  <td>{l.entity_type}</td>
                  <td className="fw-600">{l.entity_id}</td>
                  <td>
                    {(l.before_value||l.after_value) && (
                      <button className="btn-small" onClick={() => setExpanded(x => ({...x, [i]:!x[i]}))}>
                        {expanded[i] ? "Hide" : "Details"}
                      </button>
                    )}
                  </td>
                </tr>
                {expanded[i] && (
                  <tr>
                    <td colSpan={6} style={{ background:"#fafafa", padding:"10px" }}>
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, fontSize:11 }}>
                        {l.before_value && <div><div style={{ fontWeight:700, marginBottom:4, color:"#888" }}>Before</div><pre style={{ margin:0, fontSize:10, whiteSpace:"pre-wrap" }}>{JSON.stringify(JSON.parse(l.before_value),null,2)}</pre></div>}
                        {l.after_value  && <div><div style={{ fontWeight:700, marginBottom:4, color:"#166534" }}>After</div><pre style={{ margin:0, fontSize:10, whiteSpace:"pre-wrap" }}>{JSON.stringify(JSON.parse(l.after_value),null,2)}</pre></div>}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
            {!loading && !logs.length && <tr><td colSpan={6} style={{ textAlign:"center", color:"#bbb", padding:32 }}>No logs found.</td></tr>}
          </tbody>
        </table>
        </div>
      </div>
    </>
  );
}
